import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import s from '../CapBoxNew/Capbox.styles';

const DeleteSiteRepresentativeIcon = styled(Svg)`
  width: 12px;
  height: 12px;
  cursor: pointer;
`;

const ExternalJobTable = styled('div')`
  width: 70%;
  
  &[class*='saqExternalUserWrapper'] {
    width: 100%;
  }
  [class*='mainTable'] {
    top: 5px;
    color: var(--dark-blue);
    font-size: 11px;
    div[class*='rt-thead'] {
      div[class*='rt-resizable-header-content'] {
        font-family: var(--ph-font-family-lato-bold) !important;
      }
      & > div[class*='rt-tr'] {
        color: var(--dark-blue);
        font-size: 11px;
      }
    }
    div[class*='rt-tbody'] {
      div[role='rowgroup'] {
        line-height: normal;
        min-height: auto !important;
        color: var(--dark-blue);

        div[class*='rt-td'] {
          font-family: var(--ph-font-family-lato-regular);
        }
      }
    }
  }

  @media screen and (max-width: 1250px) {
    width: 60%;
  }

  @media screen and (max-width: 800px) {
    width: 100%
  }
`

const ModalWrapper = styled('div')`
  [class*='small-container'] {
    left: calc(50% - 200px) !important;
    top: 35%;
    width: 300px;
  }
`;

const ModalButtonWrapper = styled('div')`
  display: flex;
  justify-content: space-between;

  [class*='bg-mint-100'] {
    width: 107px;
  }
`;

export default {
  ...s,
  DeleteSiteRepresentativeIcon,
  ExternalJobTable,
  ModalWrapper,
  ModalButtonWrapper
}  
